import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API_CONFIGURED = !BACKEND_URL || /^https?:\/\//i.test(BACKEND_URL);
// Production uses one HTTPS origin: nginx serves the React build and proxies
// /api to FastAPI. Local development can still provide an explicit backend URL.
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const _token = { current: null };

export function setAuthToken(t) {
  _token.current = t;
  if (t) localStorage.setItem("sq_token", t);
  else localStorage.removeItem("sq_token");
}

export function getAuthToken() {
  if (_token.current) return _token.current;
  const stored = localStorage.getItem("sq_token");
  if (stored) _token.current = stored;
  return _token.current;
}

export const api = axios.create({
  baseURL: API_BASE,
  // A stopped local API previously left the sign-in button spinning forever.
  // Bound every request so the UI can report the actual availability problem.
  timeout: 10000,
});

api.interceptors.request.use((cfg) => {
  const t = getAuthToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      setAuthToken(null);
      if (typeof window !== "undefined" && !["/login","/activate"].includes(window.location.pathname)) {
        window.location.assign("/login");
      }
    }
    return Promise.reject(err);
  }
);
